function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M4.881 15.243a5.71 5.71 0 01-.642-.714 34.8 34.8 0 01-3.923-7.6A5.075 5.075 0 014.262.099a.784.784 0 00.184-.095h1.415a12.026 12.026 0 011.924.688 4.98 4.98 0 012.362 6.089 35.118 35.118 0 01-4.152 8.022 2.8 2.8 0 01-.46.443zm.321-.928c.43-.693.807-1.265 1.148-1.859a29.825 29.825 0 002.921-6.054 4.238 4.238 0 10-8.145-.063 34.841 34.841 0 004.076 7.971z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.054 5.237a2.846 2.846 0 11-2.823-2.844 2.811 2.811 0 012.823 2.844zM5.188 3.353A1.889 1.889 0 107.105 5.22a1.871 1.871 0 00-1.917-1.867z"
}));

var SvgMap = function SvgMap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.43,
    height: 15.243,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map.91d4d861.svg";
export { ForwardRef as ReactComponent };